import React from 'react';
import classnames from 'classnames';

import * as styles from './styles.module.scss';
import useLocale from 'hooks/useLocale';
import Formating from 'assets/js/formating';

const Description = ({
  data: {
    blog: { itemSubtitle },
    dateGmt,
  },
}) => {
  const locale = useLocale();

  return (
    <div className={styles.desc}>
      <div className={classnames('cr-lead cr-text-1', styles.desc_text)}>
        {itemSubtitle}
      </div>

      <div className={styles.desc_date}>
        <p className={classnames('cr-sub cr-text-2')}>
          {Formating.date(dateGmt, locale.code)}
        </p>
      </div>
    </div>
  );
};

export default Description;
